import { render, staticRenderFns } from "./DashboardPortalApi.vue?vue&type=template&id=5f23e51d&scoped=true&"
import script from "./DashboardPortalApi.vue?vue&type=script&lang=js&"
export * from "./DashboardPortalApi.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPortalApi.vue?vue&type=style&index=0&id=5f23e51d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f23e51d",
  null
  
)

export default component.exports